// extracted by mini-css-extract-plugin
export default {"benefits":"lbOkl","benefit":"DObKA","star":"xOMam"};